import { Injectable } from '@angular/core';
import { Guid } from '@models/guid';
import { MediaType } from '@models/imported/SagaBase';
import { DataType } from '@models/imported/SagaBase/Interfaces';
import { MediaSource } from '../../schema/enums/media-source';
import { ICustomFile } from '../../schema/interfaces/ICustomFile';
import { CameraProviderService } from '../camera-provider/camera-provider.service';
import { FileChooserService } from '../file-chooser/file-chooser.service';
import { ThumbnailService } from '../thumbnail/thumbnail.service';
import { UploadService } from '../upload/upload.service';

@Injectable({
  providedIn: 'root'
})
export class AttachmentService {
  constructor(
    private cameraProvider: CameraProviderService,
    private fileChooser: FileChooserService,
    private thumbnailService: ThumbnailService,
    private uploadService: UploadService
  ) {}

  createAttachment(parentId: Guid, mediaSource: MediaSource): Promise<boolean> {
    return this.selectFile(mediaSource, parentId)
      .then(customFile => this.setAttachmentDataType(customFile))
      .then(file => this.uploadService.upload(file))
      .catch(console.log.bind(console));
  }

  createMediaMessage(parentId: Guid, mediaSource: MediaSource): Promise<boolean> {
    return this.selectFile(mediaSource, parentId)
      .then(file => this.uploadService.upload(file, true))
      .catch(console.log.bind(console));
  }

  private selectFile(mediaSource: MediaSource, parentId): Promise<ICustomFile> {
    return (mediaSource === MediaSource.File ? this.fileChooser.choose(mediaSource) : this.cameraProvider.showCamera(mediaSource))
      .then(customFile => (customFile ? customFile : Promise.reject('select file canceled')))
      .then(customFile => this.setParent(customFile, parentId))
      .then(customFile => this.setThumbnail(customFile));
  }

  private setParent(customFile: ICustomFile, parentId: Guid): ICustomFile {
    customFile.parent = parentId;
    return customFile;
  }

  private setThumbnail(customFile: ICustomFile): Promise<ICustomFile> {
    return this.thumbnailService.createThumbnail(customFile).then(thumbnail => {
      customFile.thumbnail = thumbnail;
      return customFile;
    });
  }

  private setAttachmentDataType(customFile: ICustomFile): ICustomFile {
    switch (customFile.dataType) {
      case MediaType.Image:
        customFile.dataType = DataType.Picture;
        break;

      case MediaType.Video:
        customFile.dataType = DataType.Video;
        break;

      case MediaType.Document:
        customFile.dataType = DataType.File;
        break;
    }

    return customFile;
  }
}
